import { useContext } from 'react'

import { Footer, Wrapper } from 'components'
import { AppContext } from 'contexts/AppContext'

export const Maintenance = () => {
  const { settings } = useContext(AppContext)

  return (
    <div
      className="w-screen h-screen bg-cover bg-no-repeat bg-center flex items-center"
      style={{
        backgroundImage: `url(images/dark_broker.jpg)`,
      }}
    >
      <Wrapper>
        <div className="flex flex-col items-center m-auto gap-x-4 gap-y-12 max-w-[700px] h-full">
          <div>
            <h1 className="text-white uppercase font-semibold text-2xl text-center tracking-wider pb-4">
              {settings?.maintenanceModeTitle || 'Manutenção'}
            </h1>
            <h2 className="text-white font-roboto  text-lg text-center">
              {settings?.maintenanceModeMessage ||
                'Estamos a realizar melhorias na plataforma. Pedimos desculpa pelo incómodo e agradecemos a sua paciência.'}
            </h2>
          </div>

          <div className="flex flex-col gap-4 items-center justify-center">
            <img
              src="/images/rocket.svg"
              alt="Innovarisk"
              className="max-w-[220px] animate-slideInFade"
            />
            <h2 className="text-white font-roboto mb-[50px] mt-[50px] text-lg text-center">
              A solução que permite de forma simples e fácil aceder aos produtos
              especializados para nichos de mercado.{' '}
            </h2>
          </div>
        </div>
      </Wrapper>
      <Footer />
    </div>
  )
}
